<template>
  <div id="blogi" class="text-center">
    <v-parallax
      src="@/assets/images/dm_blogi.jpg"
      height="300"
      class="blog__parallax"
    >
      <h1 class="text-center">Blogi</h1>
      Zapraszamy do lektury
      <v-card
        width="450"
        class="pa-4 mt-6 card-center"
        hover
        href="https://wygrajwkio.pl"
      >
        <h2>Wygraj w KIO</h2>
        <div>
          Blog o prawach wykonawców zamówień publicznych
        </div>
      </v-card>
    </v-parallax>
  </div>
</template>

<script>
export default {
  name: 'Blog',
};
</script>

<style scoped>
h1 {
  color: white;
}
.card-center {
  margin: auto;
}
.blog__parallax >>> .v-parallax__image {
  /* width: 100%; */
}
</style>
